/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImageQuality } from './ImageQuality';
import {
    ImageQualityFromJSON,
    ImageQualityFromJSONTyped,
    ImageQualityToJSON,
    ImageQualityToJSONTyped,
} from './ImageQuality';
import type { ImageSize } from './ImageSize';
import {
    ImageSizeFromJSON,
    ImageSizeFromJSONTyped,
    ImageSizeToJSON,
    ImageSizeToJSONTyped,
} from './ImageSize';

/**
 * 
 * @export
 * @interface ImageGenerationRequest
 */
export interface ImageGenerationRequest {
    /**
     * 
     * @type {string}
     * @memberof ImageGenerationRequest
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof ImageGenerationRequest
     */
    modelId: string;
    /**
     * 
     * @type {number}
     * @memberof ImageGenerationRequest
     */
    imageCount: number;
    /**
     * 
     * @type {string}
     * @memberof ImageGenerationRequest
     */
    backgroundColor?: string | null;
    /**
     * 
     * @type {ImageSize}
     * @memberof ImageGenerationRequest
     */
    imageSize?: ImageSize | null;
    /**
     * 
     * @type {ImageQuality}
     * @memberof ImageGenerationRequest
     */
    imageQuality?: ImageQuality | null;
    /**
     * 
     * @type {string}
     * @memberof ImageGenerationRequest
     */
    userName?: string | null;
}



/**
 * Check if a given object implements the ImageGenerationRequest interface.
 */
export function instanceOfImageGenerationRequest(value: object): value is ImageGenerationRequest {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('modelId' in value) || value['modelId'] === undefined) return false;
    if (!('imageCount' in value) || value['imageCount'] === undefined) return false;
    return true;
}

export function ImageGenerationRequestFromJSON(json: any): ImageGenerationRequest {
    return ImageGenerationRequestFromJSONTyped(json, false);
}

export function ImageGenerationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageGenerationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'modelId': json['modelId'],
        'imageCount': json['imageCount'],
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'imageSize': json['imageSize'] == null ? undefined : ImageSizeFromJSON(json['imageSize']),
        'imageQuality': json['imageQuality'] == null ? undefined : ImageQualityFromJSON(json['imageQuality']),
        'userName': json['userName'] == null ? undefined : json['userName'],
    };
}

export function ImageGenerationRequestToJSON(json: any): ImageGenerationRequest {
    return ImageGenerationRequestToJSONTyped(json, false);
}

export function ImageGenerationRequestToJSONTyped(value?: ImageGenerationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'modelId': value['modelId'],
        'imageCount': value['imageCount'],
        'backgroundColor': value['backgroundColor'],
        'imageSize': ImageSizeToJSON(value['imageSize']),
        'imageQuality': ImageQualityToJSON(value['imageQuality']),
        'userName': value['userName'],
    };
}

